import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MDTypography from "../../../../../components/MDTypography";
import { Box, Divider } from "@mui/material";

export const KPIHint = ({ title, sections }) => {
    const content = (
        <Box sx={{ p: 1 }}>
            <MDTypography variant="subtitle1" sx={{ fontWeight: 700, mb: 0.75 }}>
                {title}
            </MDTypography>

            <Divider sx={{ mb: 1 }} />

            {Array.isArray(sections) &&
                sections.map((s, i) => (
                    <Box key={i} sx={{ mb: i === sections.length - 1 ? 0 : 1 }}>
                        <MDTypography
                            variant="caption"
                            sx={{ fontWeight: 700, display: "block", mb: 0.25 }}
                        >
                            {s.label}
                        </MDTypography>
                        <MDTypography
                            variant="caption"
                            sx={{ display: "block", lineHeight: 1.6, opacity: 0.9 }}
                        >
                            {s.text}
                        </MDTypography>
                    </Box>
                ))}
        </Box>
    );

    return (
        <Tooltip
            title={content}
            arrow
            placement="top"
            enterDelay={200}
            slotProps={{
                tooltip: {
                    sx: {
                        bgcolor: "#fff",
                        color: "rgba(0,0,0,0.87)",
                        border: "1px solid rgba(0,0,0,0.12)",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                        borderRadius: 2,
                        maxWidth: 420,
                    },
                },
                arrow: {
                    sx: { color: "#fff" },
                },
            }}
        >
            <IconButton
                size="small"
                sx={{ ml: 1, opacity: 0.7, "&:hover": { opacity: 1 } }}
            >
                <InfoOutlinedIcon fontSize="inherit" />
            </IconButton>
        </Tooltip>
    );
};
